export function pickDisplayPrice(product, currency) {
  const dp = product?.displayPrices || null;
  const scope = currency === "TRY" ? "tr" : "intl";

  // 1) İstenen currency
  let val = dp?.[scope]?.[currency];
  if (val != null) return { amount: Number(val), curr: currency };

  // 2) Aynı blokta USD fallback
  val = dp?.[scope]?.USD;
  if (val != null) return { amount: Number(val), curr: "USD" };

  // 3) Global fallback: intl.USD
  val = dp?.intl?.USD;
  if (val != null) return { amount: Number(val), curr: "USD" };

  // 4) Legacy price (örn "3.150" string)
  const legacy = product?.price;
  if (legacy != null && legacy !== "") {
    const n = Number(String(legacy).replace(/\./g, "").replace(",", "."));
    if (!Number.isNaN(n)) return { amount: n, curr: currency };
  }

  // hiçbiri yoksa null
  return null;
}

export function formatMoney(amount, curr, opts = { min: 0, max: 0 }) {
  return `${Number(amount).toLocaleString(undefined, {
    minimumFractionDigits: opts.min,
    maximumFractionDigits: opts.max,
  })} ${curr}`;
}
